/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { themeV2, pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- CHART TABLE : STYLES --------------- ++++++++++ */
export default {
    charttable: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: pxToEm(81),
        // width: pxToEm(234),
        boxShadow: 'inset 0px -1px 0px 0px rgb(231, 236, 247);',
        marginTop: pxToEm(53),
        padding: `${pxToEm(14)} 0px`,
        '& .title': {
            color: props => props.titleColor
        },
        '& .valuebadge':{
            display: 'flex',
            justifyContent: 'space-between',
            '& .badgechange': {
                display: 'flex',
                alignItems: 'center',
                '& .changetype': {
                    color: themeV2.color.base.gray.dark,
                    fontSize: pxToEm(12),
                    marginLeft: pxToEm(8)
                }
            }
        }
    }
};
